import mockupPhone from "../../assets/img/download/phone-mockup.webp";
import GooglePlay from "../../assets/img/download/google-play.svg";
import AppStore from "../../assets/img/download/app-store.svg";
import React from "react";
import Rive, {Layout} from "rive-react";
import bgRiv from "../../assets/img/background/bg-black-animated.riv";

export default function DownloadAppSection(){
    return (
        <div className="container-6">
            <div className="card">
                <div className="imagePart">
                    <img src={mockupPhone} alt='mockup application'/>
                </div>
                <div className="textPart">
                    <div className="rive-background">
                        <Rive
                            src={bgRiv}
                            layout={new Layout({fit: "cover", alignment: "center"})}
                            style={{width: "100%", height: "100%"}}
                        />
                    </div>
                    <div className="explanation-text">
                        <h2 className="text-header">Download Aplikasi Mobile <span>Danai.id</span></h2>
                        <p className="text-white m-0">Dapatkan kemudahan dalam memberikan pendanaan, mengajukan pinjaman
                            serta berbagai transaksi seperti pembayaran dan transfer, kapan pun dimana pun.</p>
                        <div className="app-btn">
                            <a href="https://play.google.com/store/apps/details?id=com.adiwisista.project"
                               target="_blank" rel="noreferrer">
                                <img className="android-app" src={GooglePlay} alt="google play"/>
                            </a>
                            <a href="https://apps.apple.com/my/app/danai-id-p2p-lending/id1503276449" target="_blank"
                               rel="noreferrer">
                                <img className="apple-app" src={AppStore} alt="app store"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}